module.exports = __webpack_public_path__ + "static/media/40x40-6.71f746ed.png";